import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "semantic-ui-react";

import { formatDateRelative } from "simplydo/core/dates";
import { OpenAPI } from "simplydo/interfaces";

import util from "utils/utils";

import RowComponent from "components/lib/RowComponent";

type HomeChallengesProps = { challenges: OpenAPI.Schemas["Challenge"][] };

function HomeChallenges({ challenges }: HomeChallengesProps) {
  const { t } = useTranslation();

  if (!challenges || !challenges.length) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title>{t("generic.challenges")}</RowComponent.Title>
        <Button as={Link} to="/challenges/discover" primary size="mini">
          {t("challenges.yours.sidebar.viewAll")}
        </Button>
      </RowComponent.Fill>
      {challenges.slice(0, 4).map((challenge, index) => (
        <RowComponent.Cell
          index={index}
          key={challenge._id}
          as={Link}
          to={`/challenges/${challenge._id}`}
        >
          <div
            style={{
              width: 50,
              height: 40,
              borderRadius: 3,
              flex: "0 0 50px",
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundImage: `url(${util.mixinCssUrlFallback(util.getImageUrl(challenge, ["coverImage", "bannerImage"], ["1280x200", "200x200"], util.challengeImage()))})`,
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: 5,
              marginRight: 5,
              position: "relative",
              top: -1,
            }}
          >
            <RowComponent.Title wrapping style={{ color: "#5d5d5d" }} block>
              {challenge.name}
            </RowComponent.Title>
            <RowComponent.StatusArea>
              {challenge.stage === "closed" ?
                <>
                  <RowComponent.StatusLabel color="red" /> {t("generic.closed")}
                </>
              : challenge.stage === "published" &&
                (challenge.deadline ?
                  <>
                    <RowComponent.StatusLabel color="blue" />
                    {t("generic.closes")}{" "}
                    {formatDateRelative(challenge.deadline, {
                      addSuffix: true,
                    })}
                  </>
                : <>
                    <RowComponent.StatusLabel color="green" />
                    {t("generic.open")}
                  </>)
              }
            </RowComponent.StatusArea>
          </div>
        </RowComponent.Cell>
      ))}
    </RowComponent>
  );
}

export default HomeChallenges;
